<template>

  <div class="wrap">

    <div class="page-header">
      <Nav :activeId="activeId" />
    </div>

    <!-- 预约展开 -->
    <div class="section-yy" id="yuyue">
      <div class="content">
        <div v-if="chooseId==1">
          <div class="address">
            <h3>上海旗舰体验中心</h3>
            <p>地址:上海市杨浦区杨树浦路288号建发国际大厦4楼401</p>
          </div>
          <!-- <div class="address">
            <h3>Shanghai Flagship Experience Center</h3>
            <p>Address: 401, 4th Floor, Jianfa lnternational Building, 288 Yangshupu Road, Yangpu District, Shanghai</p>
          </div> -->
        </div>
        <div v-if="chooseId==2">
          <div class="address">
            <h3>北京活水体验中心</h3>
            <p>地址:北京市朝阳区北四环东路亚振家居广场B1</p>
          </div>
          <!-- <div class="address">
            <h3>Beijing Living Water Experience Center</h3>
            <p>Address: B1, Yazhen Home Plaza, East North Fourth Ring Road, Chaoyang District, Beijing</p>
          </div> -->
        </div>
        <div v-if="chooseId==3">
          <div class="address">
            <h3>贵阳旗舰体验中心</h3>
            <p>地址:贵州省贵阳市南明区油榨街10号红星美凯龙1号店2号写字楼19楼</p>
          </div>
          <!-- <div class="address">
            <h3>Guiyang Flagship Experience Center</h3>
            <p>Address: 19th Floor, Office Building 2, Red Star Macalline Store 1, No. 10 Youzha Street, Nanming District, Guiyang City, Guizhou Province</p>
          </div> -->
        </div>
        <div v-if="chooseId==4">
          <div class="address">
            <h3>宁波旗舰店体验中心</h3>
            <p>地址:宁波市鄞州区中山东路1751号德克德家国际家居3楼322班尼戈</p>
          </div>
          <!-- <div class="address">
            <h3>Ningbo Flagship Store Experience Center</h3>
            <p>Address: 322 Benigo, 3rd Floor, Deker Dejia International Home Furnishing, No. 1751, Zhongshan East Road, Yinzhou District, Ningbo City</p>
          </div> -->
        </div>
        
        <!-- 选择地点-照片 -->
        <div class="choose">
          <div :class="['pic', {'hover': chooseId==1}]" @click="onChoose(1)">
            <img src="../../img/appointment/city/1.jpg" class="bg" />
            <!-- <div class="cover">SHANGHAI<br/>上海</div> -->
            <div class="cover">上海</div>
          </div>
          <div :class="['pic', {'hover': chooseId==2}]" @click="onChoose(2)">
            <img src="../../img/appointment/city/2.jpg" class="bg" />
            <!-- <div class="cover">BEIJING<br/>北京</div> -->
            <div class="cover">北京</div>
          </div>
          <div :class="['pic', {'hover': chooseId==3}]" @click="onChoose(3)">
            <img src="../../img/appointment/city/3.jpg" class="bg" />
            <!-- <div class="cover">GUIYANG<br/>贵阳</div> -->
            <div class="cover">贵阳</div>
          </div>
          <div :class="['pic', {'hover': chooseId==4}]" @click="onChoose(4)">
            <img src="../../img/appointment/city/4.jpg" class="bg" />
            <!-- <div class="cover">NINGBO<br/>宁波</div> -->
            <div class="cover">宁波</div>
          </div>
        </div>

        <!-- 表单填写 -->
        <div class="form">
          <van-form @submit="onSubmit">
            <van-cell-group>
              <van-field name="name" v-model="name" label="姓名：" label-width="" placeholder="请输入姓名" />
            </van-cell-group>

            <van-cell-group class="input-group">
              <van-field name="gender" label="性别：" label-width="">
                <template #input>
                  <van-radio-group v-model="gender" direction="horizontal">
                    <van-radio name="1">男</van-radio>
                    <van-radio name="2">女</van-radio>
                  </van-radio-group>
                </template>
              </van-field>

              <van-field  name="tel" v-model="tel" type="tel" label="手机号：" label-width="" placeholder="请输入手机号" />
            </van-cell-group>
             
            <van-cell-group class="input-group">
              <van-field name="num" label="人数：">
                <template #input>
                  <van-stepper v-model="num" />
                </template>
              </van-field>
      
              <!-- <van-field
                readonly
                clickable
                name="calendar"
                :value="value"
                label="时间："
                placeholder="点击选择日期"
                @click="showCalendar = true"
              > -->

              <div class="input-calendar van-field">
                <div class="calendar-label van-field__label">时间：</div>
                <div class="calendar-body">
                  <calendar 
                    v-model="value2" 
                    show-date-only
                    :disabled-days-of-week="disabled" 
                    :format="format"
                    :clear-button="clear" 
                    :placeholder="placeholder" 
                    :lang="lang" 
                    :position="position" 
                    :on-day-click="dayClick"
                  ></calendar>
                </div>
              </div>

              <!-- </van-field> -->
              <!-- <van-calendar v-model="showCalendar" @confirm="onConfirm" /> -->
            </van-cell-group>

            <div class="form-submit form-agree">
              <van-checkbox v-model="checked">
                我阅读并同意 <span>服务条款</span> 和 <span>隐私保护协议</span>
              </van-checkbox>
            </div>
            <div class="form-submit">
              <van-button round block plain color="#FFF" type="info" native-type="submit">确认预约</van-button>
            </div>

          </van-form>
        </div>
      </div>
      
    </div>

    <Footer />
  </div>

</template>

<script>
// in ES6 modules
import Calendar from 'vue2-slot-calendar';
import { savaAppointment } from "@/api/index";
import { Toast } from "vant";
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      activeId: 1,
      // chooseId: '',
      chooseId: '',

      name: '',
      tel: '',
      gender: 1,
      num: 1,
      value: '',
      showCalendar: false,
      checked: true,

      disabled: [], //禁用的日期
      // value2: new Date(), //值
      value2: "",
      format: "yyyy-MM-dd", //文本框中显示的日期格式
      clear: false, //是否在文本框右侧显示清除按钮（X）
      placeholder: "点击选择日期", //水印
      position: "left", //日期面板位置，默认null和left 居左，right则靠右
      lang: "" //语言，默认中文，可选值：zh-CN、en
    }
  },
  components: {
    Nav,
    Footer,
    Calendar
  },
  mounted() {
  },
  methods: {
    dayClick: function(date, dateStr) {
      console.log(date);
      console.log(dateStr);
      console.log(this.value);
    },
    openYuyue() {
      this.yuyue = true;
    },
    onChoose(id) {
      // let id = e.target.dataset.id
      // console.log(id)
      this.chooseId = id
    },
    onSubmit(values) {
      console.log('submit', values);
      if ( !this.chooseId ) {
        Toast("请选择预约城市");
        return;
      }
      if ( !this.name ) {
        Toast("请填写姓名");
        return;
      }
      if ( !this.gender ) {
        Toast("请选择性别");
        return;
      }
      if ( !this.tel ) {
        Toast("请填写手机号");
        return;
      }
      if ( !this.num ) {
        Toast("请填写人数");
        return;
      }
      if ( !this.value2 ) {
        Toast("请选择预约日期");
        return;
      }
      const params = {
        district_id: this.chooseId,
        name: this.name,
        tel: this.tel,
        gender: this.gender,
        people_num: this.num,
        appointment_date: this.value2
      }
      console.log(params);
      savaAppointment(params).then((res) => {
        console.log(res);
        if ( res.data.status ) {
          Toast("提交成功！");
        } else {
          Toast("提交失败，请稍后再试！");    
        }
      });
    },
    onConfirm(date) {
      this.value = `${date.getMonth() + 1}/${date.getDate()}`;
      this.showCalendar = false;
    }
  }
};
</script>

<style  lang="less">
.section-yy {
  min-height: 1200px;
  background: url('../../img/appointment/bg.jpg') center top no-repeat;
  background-size: 100% 830px;
  // background-size: 100%;
  padding: 960px 0 200px;
  .content {
    width: 1110px;
    margin: 0 auto;
    color: #FFF;
    .address {
        font-size: 16px;
        color: #FFF;
        margin-bottom: 50px;
        h3 {
            font-size: 24px;
        }
    }
    .choose {
        display: flex;
        justify-content: space-between;
        flex-flow: row wrap;
        .pic {
            width: 530px;
            height: 312px;
            position: relative;
            margin-bottom: 40px;
            cursor: pointer;
            .bg {
                position: absolute;
                z-index: -99;
            }
            img {
                width: 100%;
                height: 100%;
            }
            .cover {
                // display: none;
                display: flex;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, .6);
                background-repeat: no-repeat;
                background-size: 202px 60px;
                background-position: center center;

                text-align: center;
                align-items: center;
                justify-content: center;
                // justify-self: center;
                // align-self: center;

                font-size: 30px;
                font-weight: bold;
            }
            &.hover {
                .cover {
                  // display: flex;
                  display: none;
                }    
            }
            &:hover {
                .cover {
                  // display: flex;
                  display: none;
                }    
            }
        }
    }
    .form {
        width: 1000px;
        margin: 100px auto 0;
    }
  }
}
.van-cell-group {
  background-color: transparent;
  margin-bottom: 30px;
  &::after {
    border: 0 none;
  }
}
.van-cell {
  border-radius: 50px;
  background: #DADADA;
  // line-height: 100% !important;
  line-height: unset !important;
}
.van-field__label {
  font-size: 20px !important;
  font-weight: bold !important;
  color: #000 !important;
}
.van-cell__value {
  display: flex;
  align-items: center;
}
.van-field {
  border-radius: 50px;
}
.input-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .van-cell {
    // width: 80%;
    width: 470px;
  }
}
.van-field__body {
  width: 100%;
}
.input-calendar {
  padding: 10px 16px;
  box-sizing: border-box;
  width: 470px;
  background-color: #DADADA;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .calendar-body {
    width: 100%;
    input {
      width: 100% !important;
    }
    // display: flex;
    // justify-content: flex-start;
    // align-items: flex-start;
  }
  // border-radius: 50rpx;
}
.form-agree {
  color: #FFF;
  padding: 50px 0 30px;
  .van-checkbox__label {
    color: #FFF;
    font-size: 16px;
  }
  span {
    text-decoration: underline;
  }
}
.form-submit {
  width: 400px;
  text-align: center;
  margin: 0 auto;
}
.van-button--plain.van-button--info {
  font-size: 24px;
  font-weight: bold;
  background: #000;
}
</style>